import Cookies from 'js-cookie';

const ADMIN_CACHE_KEY = 'admin_status_cache';
const CACHE_DURATION_HOURS = 2; // Cache for 2 hours

interface AdminCacheData {
  isAdmin: boolean;
  userId: string;
  timestamp: number;
}

export const setAdminStatusCache = (isAdmin: boolean, userId: string) => {
  const cacheData: AdminCacheData = {
    isAdmin,
    userId,
    timestamp: Date.now()
  };
  
  Cookies.set(ADMIN_CACHE_KEY, JSON.stringify(cacheData), {
    expires: CACHE_DURATION_HOURS / 24, // Convert hours to days for js-cookie
    secure: window.location.protocol === 'https:',
    sameSite: 'lax'
  });
};

export const getAdminStatusCache = (currentUserId: string): boolean | null => {
  try {
    const cached = Cookies.get(ADMIN_CACHE_KEY);
    if (!cached) return null;
    
    const cacheData: AdminCacheData = JSON.parse(cached);
    
    // Verify the cache is for the current user
    if (cacheData.userId !== currentUserId) {
      clearAdminStatusCache();
      return null;
    }
    
    // Check if cache has expired
    const now = Date.now();
    const cacheAge = now - cacheData.timestamp;
    const maxAge = CACHE_DURATION_HOURS * 60 * 60 * 1000; // Convert to milliseconds
    
    if (cacheAge > maxAge) {
      clearAdminStatusCache();
      return null;
    }
    
    return cacheData.isAdmin;
  } catch (error) {
    console.error('Error reading admin cache:', error);
    clearAdminStatusCache();
    return null;
  }
};

export const clearAdminStatusCache = () => {
  Cookies.remove(ADMIN_CACHE_KEY);
};